import React,{Fragment, useEffect, useState, useRef} from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import Loader from '../../common/loaderapp';
import Switch from '@material-ui/core/Switch'
import { BANNER_TYPES } from '../../../constant/bannerTypes';
import { LEVEL_ONE_ORDER_OPTIONS, isLevelOneBanner } from '../../../utils/bannerOrder';

const FormularioBanner = ({datos,setDatos}) => {

    const ref_url = useRef();

    const [sucursales, setSucursales] = useState([]);
    const [is_loader_options, setIs_loader_options] = useState(true);

    const [sugerenciasUrl, setSugerenciasUrl] = useState([]);
    const [mostrarSug, setMostrarSug] = useState(false);

    const actBanner = (e) => {
        const { name, value } = e.target;

        if (name === 'ruta') {
            setDatos({ ...datos, ruta: value });

            if (value.trim() === "") {
                setMostrarSug(false);
                setSugerenciasUrl([]);
            } else {
                setSugerenciasUrl([
                    value,
                    `https://${value}`,
                    `https://www.google.com/search?q=${value}`
                ]);
                setMostrarSug(true);
            }
            return;
        }

        if (name === 'orden_banner') {
            const nextOrder = value === '' ? '' : parseInt(value, 10);
            setDatos({ ...datos, orden_banner: nextOrder });
            return;
        }

        if (name === 'tipo_banner') {
            const nextValue = value === '' ? 0 : parseInt(value, 10);
            const forceOrderOne = nextValue === 1 || nextValue === 3;
            setDatos({
                ...datos,
                tipo_banner: nextValue,
                orden_banner: forceOrderOne ? 1 : datos.orden_banner
            });
            return;
        }

        setDatos({ ...datos, [name]: value });
    };

    useEffect(() => {
        fetch('/p_banners', { headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {
            setIs_loader_options(false);
            setSucursales(res) 
        })
        .catch(err => { console.log('Error: ' + err) })
    }, []);

    function isValidHttpUrl(s) {
        let url;
        try {
          url = new URL(s);
        } catch (e) { return false; }
        return /https?/.test(url.protocol);
    }

    const comprobarRuta = (()=> {
        let url_input = ref_url.current;

        if(isValidHttpUrl(datos.ruta)){
            url_input.classList.remove('is-invalid')
            setDatos({ ...datos, ruta_valida:true})
        }
        else{
            url_input.classList.add('is-invalid')
            setDatos({ ...datos, ruta_valida:false})
        }
    });

    const isNivelUno = isLevelOneBanner(datos.tipo_banner);

    return (
        <Fragment>
            <div className="row my-4">

                <div className="col-sm-12 col-md-4">
                    <div className="form-group">
                        <label className="form-label">Nombre*</label>
                        <input
                            name="nombre"
                            value={datos.nombre}
                            className="form-control"
                            onChange={actBanner}
                            type="text"
                            autoComplete="off"
                        />
                        <div className="invalid-feedback">Debes asignar un nombre</div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="form-group">
                        <label className="form-label">Tipo de banner*</label>
                        <select
                            name="tipo_banner"
                            className={`form-control ${datos.tipo_banner ? '' : 'is-invalid'}`}
                            value={datos.tipo_banner || ''}
                            onChange={actBanner}
                        >
                            <option value="">Selecciona una opción</option>
                            {BANNER_TYPES.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                        <div className="invalid-feedback">Debes seleccionar un tipo de banner</div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="form-group">
                        <label className="form-label">Orden*</label>
                        {isNivelUno ? (
                            <select
                                name="orden_banner"
                                className={`form-control ${datos.orden_banner ? '' : 'is-invalid'}`}
                                value={datos.orden_banner ?? ''}
                                onChange={actBanner}
                            >
                                <option value="">Selecciona un orden</option>
                                {LEVEL_ONE_ORDER_OPTIONS.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        ) : (
                            <input className="form-control" value="1" disabled />
                        )}
                        {isNivelUno ? (
                            <div className="invalid-feedback">Debes seleccionar un orden para Nivel 1</div>
                        ) : (
                            datos.tipo_banner ? (
                                <small className="text-warning d-block mt-1">
                                    Este nivel solo tiene un espacio disponible y se reemplazará el banner existente.
                                </small>
                            ) : null
                        )}
                    </div>
                </div>

                <div className="col-sm-12 col-md-4">
                    <label className="form-label">Sucursal*</label>
                    <div className="form-group">
                        <Typeahead
                            id="basic-typeahead"
                            labelKey={option => option.ESTADO_US ? `${option.CIUDAD_US} - ${option.ESTADO_US}` : option.CIUDAD_US}
                            options={sucursales}
                            placeholder="Sucursal..."
                            clearButton
                            paginate={false}
                            maxResults={600}
                            emptyLabel={is_loader_options ? <Loader/> : 'Sin opciones'}
                            selected={sucursales.filter(x => x.ID_US == datos.sucursal)}
                            onChange={val => setDatos({ ...datos, sucursal: val.length === 0 ? 0 : val[0].ID_US })}
                        />
                        <div className="invalid-feedback">Debes asignar una sucursal</div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="form-group mt-4 text-center shadow shadow-showcase p-1">
                        <label className="form-label mb-0">¿Redirecciona a un link?</label>
                        <Switch
                            color="primary"
                            onChange={() => setDatos({ ...datos, es_ruta: !datos.es_ruta })}
                            checked={datos.es_ruta}
                        />
                        <label className="form-label">{datos.es_ruta ? 'Si' : 'No'}</label>
                    </div>
                </div>

                {datos.es_ruta && (
                    <div className="col-sm-12 col-md-4">
                        <div className="form-group" style={{ position: "relative" }}>
                            <label className="form-label">URL</label>

                            <input
                            ref={ref_url}
                            name="ruta"
                            className="form-control"
                            value={datos.ruta}
                            onChange={actBanner}
                            type="text"
                            autoComplete="off"
                            onBlur={comprobarRuta}
                            onFocus={() => datos.ruta && setMostrarSug(true)}
                            />

                            <div className="invalid-feedback">
                            URL inválido, el url debe empezar por https://
                            </div>

                            {/* Vista previa de la URL */}
                            {mostrarSug && datos.ruta && (
                            <div
                                style={{
                                marginTop: "6px",
                                padding: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                background: "#f8f9fa",
                                fontSize: "0.9rem"
                                }}
                            >
                                {sugerenciasUrl.map((sug, i) => (
                                <div key={i} style={{ color: "#555" }}>
                                    {sug}
                                </div>
                                ))}
                            </div>
                            )}
                        </div>
                        </div>

                )}

                <div className="col-sm-12 col-md-4">
                    <div className="form-group mt-4 text-center shadow shadow-showcase p-1">
                        <label className="form-label mb-0">Estatus:</label>
                        <Switch
                            color="primary"
                            onChange={() => setDatos({ ...datos, estatus: !datos.estatus })}
                            checked={datos.estatus}
                        />
                        <label className="form-label">{datos.estatus ? 'Público' : 'Privado'}</label>
                    </div>
                </div>

            </div>
        </Fragment>
    );
};

export default FormularioBanner;
